import { FunctionComponent } from 'react';
import { CardActions, DetailsContentCommon, DetailsContentProps } from '../../../shared';

export const DetailsContent: FunctionComponent<DetailsContentProps> = ({
  card,
  chatId,
  scrollToTags,
  scrollToComments,
  activeCommentsInput,
  commentsWrapper,
  isPageView,
}) => {
  return (
    <DetailsContentCommon
      card={card}
      chatId={chatId}
      scrollToTags={scrollToTags}
      scrollToComments={scrollToComments}
      activeCommentsInput={activeCommentsInput}
      commentsWrapper={commentsWrapper}
      CardActionsComponent={CardActions}
      isPageView={isPageView}
    />
  );
};
